export const PERMISSION_GROUPS_ORDER = [
  'Identity & administration',
  'Students & profiles',
  'Cohorts, groups & enrollment',
  'Courses, content & assessments',
  'Communication & engagement',
  'Analytics & reporting',
  'Community & support',
  'Platform & automation',
  'Other',
];

export function getPermissionGroup(name) {
  if (!name || typeof name !== 'string') return 'Other';
  const n = name;

  if (/^(TriggerAIGrading|OverrideGrade)$/.test(n)) {
    return 'Courses, content & assessments';
  }

  if (
    /^(ManageAdministrators|ManageRoles|ViewAdminActivity|AccessAudit)/i.test(n)
  ) {
    return 'Identity & administration';
  }
  if (
    /^(GetStudents|UpdateStudent|OnboardStudents|ViewStudent|ExportStudent|Certify|ManageSuperStudents)/i.test(
      n
    )
  ) {
    return 'Students & profiles';
  }
  if (
    /^(ManageAdmissions|ManageForms$|CreateCohort|UpdateCohort|CreateGroup|UpdateGroup|AddGroup|DeleteGroup|CreateModuleInstructor|DeleteModuleInstructor|CreateGroupAssignment)/i.test(
      n
    )
  ) {
    return 'Cohorts, groups & enrollment';
  }
  if (
    /^(CreateCourse|UpdateCourse|CreateCourseModule|UpdateCourseModule|CreateWeek|UpdateWeek|DeleteWeek|CreateLesson|UpdateLesson|DeleteLesson|CreateEvent|UpdateEvent|DeleteEvent|CreateQuiz|UpdateQuiz|DeleteQuiz|CreateTutorial|UpdateTutorial|CreateAssignment|UpdateAssignment|DeleteAssignment|CreateClassSession|UpdateClassSession|DeleteClassSession|CreateSurvey|UpdateSurvey|DeleteSurvey)/i.test(
      n
    )
  ) {
    return 'Courses, content & assessments';
  }
  if (
    /^(CreateCohortEmail|SendPush|SendSms|SendImpactReport|ManageJobDigest|AddJobs|ManageCohortAlerts|ManageBulk|ManageOnboarding|ManageHPF|NotifyStudent)/i.test(
      n
    )
  ) {
    return 'Communication & engagement';
  }
  if (/^View(Scholarship|Paid|Admin|Students|Class|Cohort)/i.test(n)) {
    return 'Analytics & reporting';
  }
  if (
    /^(UnflagCommunity|DeleteCommunity|UpdateTicket|ManageTicket|ManageForum)/i.test(
      n
    )
  ) {
    return 'Community & support';
  }
  if (
    /^(ManageCertificate|ManagePartner|ManageIntegration|Regenerate|DeleteCohort|AssignPrefix|Trigger)/i.test(
      n
    )
  ) {
    return 'Platform & automation';
  }
  return 'Other';
}

export function groupPermissionsByCategory(actions) {
  const map = new Map();
  PERMISSION_GROUPS_ORDER.forEach((g) => map.set(g, []));

  (actions || []).forEach((action) => {
    const group = getPermissionGroup(action?.name);
    if (!map.has(group)) map.set(group, []);
    map.get(group).push(action);
  });

  return PERMISSION_GROUPS_ORDER.filter(
    (g) => (map.get(g) || []).length > 0
  ).map((g) => ({
    title: g,
    actions: map.get(g) || [],
  }));
}
